module.exports = __webpack_public_path__ + "static/logo21-34172bd5fce74af09503d133dc772c9b.png";